import React from 'react';
import PropTypes from 'prop-types';
import SearchIcon from './components/SearchIcon';
import LeftArrow from './components/LeftArrow';
import Loading from './components/Loading';
import SelectCardIcon from './components/SelectCardIcon';
import PlusIcon from './components/PlusIcon';
import SortAZIcon from './components/SortAZIcon';
import SingleUserIcon from './components/SingleUserIcon';
import MultiUserIcon from './components/MultiUserIcon';

const Icon = props => {
  const { type, ...rest } = props;

  let ReturnIcon;
  switch (type) {
  case 'search':
    ReturnIcon = SearchIcon;
    break;
  case 'leftArrow':
    ReturnIcon = LeftArrow;
    break;
  case 'loading':
    ReturnIcon = Loading;
    break;
  case 'selectCard':
    ReturnIcon = SelectCardIcon;
    break;
  case 'plus':
    ReturnIcon = PlusIcon;
    break;
  case 'sortAZ':
    ReturnIcon = SortAZIcon;
    break;
  case 'singleUser':
    ReturnIcon = SingleUserIcon;
    break;
  case 'multiUser':
    ReturnIcon = MultiUserIcon;
    break;
  default:
    ReturnIcon = <div>Empty</div>;
  }

  return <ReturnIcon {...rest} />;
};
Icon.propTypes = { type: PropTypes.string.isRequired };

export default Icon;
